module.exports = __webpack_public_path__ + "img/avatar.fda3837f.png";